module.exports = __webpack_public_path__ + "img/horizontal_3_6_r_pp3_5012.89140396.png";